import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, HttpClientService } from 'lib/ng2-sapmp/src/providers';
import { throwError } from 'rxjs';
import { HttpResponse, HttpHeaders } from '@angular/common/http';

@Injectable()
export class FaqService {
  constructor(private utilityService: UtilityService,
    private httpClientService: HttpClientService) { }

  handleError = (error) => {
    return throwError(error);
  }

  getFaqDetails() {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'text/json');
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return this.httpClientService.get(this.utilityService.getEnvConfig().faqServiceUrl, headers)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res.body);
        return res.body;
      }
      )
      ,catchError( this.handleError ));
  }
}
